/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  PropType,
  nextTick,
  watch,
} from "vue";

export default defineComponent({
  name: "c-select-create",

  props: {
    value: {
      validator: () => true,
    },
    loading: { type: Boolean, default: false },
    label: { type: String, default: "" },
    error: { type: [Boolean, String], default: false },
    showError: { type: [Boolean, String], default: true },
    style: { type: String, default: "" },
    class: { type: String, default: "" },
    schema: { type: Function as PropType<() => void>, default: () => ({}) },
    searchable: { type: Boolean, default: true },
    placeholder: { type: String, default: "" },
    readonly: { type: Boolean, default: false },
    isArray: { type: Boolean, default: false },
    single: { type: Boolean, default: false },
    isIcon: { type: Boolean, default: true },
    required: { type: Boolean, default: false },
    isTop: { type: Boolean, default: false },
  },

  emits: ["update:value", "enter"],

  setup(props, { emit }) {
    const className = ref<string>(props.class);
    const styleName = ref<string>(props.style);
    const isRequired = ref<boolean>(false);
    const updatedLabel = ref<string>("");
    const isDropdown = ref<boolean>(false);
    const refIds = "cSelectDropdown";

    const keySearch = ref("");
    const selectedValue = ref<any[]>(
      Array.isArray(props.value) ? props.value : []
    );
    const isCreateSelect = ref<boolean>(false);

    const isError = computed(() => {
      return props.error && String(props.error);
    });

    const listRequired = () => {
      if (props.label && props.label.includes("*")) {
        updatedLabel.value = props.label.replace(/\*/g, "");
        isRequired.value = true;
      } else {
        isRequired.value = false;
        updatedLabel.value = props.label;
      }
    };

    watch(
      () => props.value,
      (newValue) => {
        selectedValue.value = Array.isArray(newValue) ? newValue : [];
      }
    );

    onMounted(() => {
      listRequired();
    });

    const onCreateKeySearch = (): void => {
      if (keySearch.value) {
        if (props.single) {
          selectedValue.value = [];
        }

        const newValue = {
          src: "",
          value: keySearch.value,
        };
        selectedValue.value = selectedValue.value.includes(newValue)
          ? selectedValue.value.filter((val) => val?.value !== keySearch.value)
          : [...selectedValue.value, newValue];
        keySearch.value = "";
        emit("update:value", selectedValue.value);
        props.schema();

        if (!isCreateSelect.value) {
          isDropdown.value = false;
        }
      }

      if (props.searchable) {
        nextTick(() => {
          if (isDropdown.value) {
            (keySearchQuery.value as HTMLInputElement).focus();
          }
        });
      }
    };

    const deleteOptionValue = (value: string) => {
      if (props.readonly) {
        return;
      }

      const index = selectedValue.value.indexOf(value);

      if (index !== -1) {
        selectedValue.value.splice(index, 1);
      }

      props.schema();
    };

    const outsideClick = (): void => {
      isDropdown.value = false;
    };

    const isLoading = computed(() => {
      return !!props.loading;
    });

    const keySearchQuery = ref<HTMLElement | null>(null);

    const onSelect = (): void => {
      if (props.readonly) {
        return;
      }

      isDropdown.value = !isDropdown.value;
      keySearch.value = "";

      if (props.searchable) {
        nextTick(() => {
          if (isDropdown.value) {
            (keySearchQuery.value as HTMLInputElement).focus();
          }
        });
      }
    };

    const focusIn = (): void => {
      isDropdown.value = true;
    };

    const focusOut = (): void => {
      isDropdown.value = false;
    };

    const handleKeyDown = (event: KeyboardEvent): void => {
      if (event.key === "Escape") {
        isDropdown.value = false;
      }
    };

    const toggleCreateSelect = (): void => {
      isCreateSelect.value = !isCreateSelect.value;

      if (props.searchable) {
        nextTick(() => {
          if (isDropdown.value) {
            (keySearchQuery.value as HTMLInputElement).focus();
          }
        });
      }
    };

    // start copy
    const showPopup = ref(false);

    const copyToClipboard = () => {
      const textArea = document.createElement("textarea");
      let valueToCopy = props.value;

      if (Array.isArray(props.value) || typeof props.value === "object") {
        valueToCopy = JSON.stringify(props.value);
      }

      textArea.value = String(valueToCopy);
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      showPopup.value = true;

      setTimeout(() => {
        showPopup.value = false;
      }, 1500);
    };
    // end copy

    return {
      refIds,
      className,
      styleName,
      isLoading,
      isError,
      isRequired,
      updatedLabel,
      onSelect,
      isDropdown,
      outsideClick,
      focusIn,
      focusOut,
      handleKeyDown,
      selectedValue,
      keySearch,
      deleteOptionValue,
      onCreateKeySearch,
      isCreateSelect,
      keySearchQuery,
      toggleCreateSelect,
      copyToClipboard,
      showPopup,
    };
  },
});
